import Vue from 'vue';

export const setBarChartRoundedTop = (chartRef, radiusPixel) => {
    // This is a workaround (also called a hack) for an Apex bug where the top of a stacked bar is not rounded if the upper segment of the bar is 0
    const seriesElements = chartRef.value.$el.querySelectorAll('.apexcharts-bar-series.apexcharts-plot-series .apexcharts-series')
    const seriesDataLength = seriesElements[0].querySelectorAll('.apexcharts-bar-area').length

    for (let i = 0; i < seriesDataLength; i++) {
        const lastElements = []

        seriesElements.forEach((el) => {
            const bar = el.querySelectorAll('.apexcharts-bar-area')[i]
            if (bar && bar.getAttribute('barHeight') !== '0') {
                lastElements.push(bar)
            }
        })

        const lastElement = lastElements[lastElements.length - 1]

        if (lastElement) {
            lastElement.setAttribute('clip-path', `inset(0% 0% -100% 0% round ${radiusPixel}px)`)
        }
    }
}

export const getComponentAsHtmlForTooltip = (component, propsData) => {
    // Get the tooltip component as HTML to use as input in ApexCharts
    const div = document.createElement('div');
    const ComponentClass = Vue.extend(component);
    const instance = new ComponentClass({
        propsData: propsData
    });
    instance.$mount(div);

    return instance.$el.outerHTML;
}

export const getDiscreteMarkers = (seriesData, seriesIndex) => {
    // This is for detecting markers to hide when the value is 0
    const discreteMarkers = [];

    seriesData.forEach((val, index) => {
        if (val === 0) {
            discreteMarkers.push({
                seriesIndex: seriesIndex,
                dataPointIndex: index,
                size: 0  // Hide marker for value 0
            });
        }
    });

    return discreteMarkers
}
